interface SecondCardProps {
  header: string;
  subheader: string;
  firstState: string;
  secondState: string;
  thirdState: string;
  firstOrders: string;
  secondOrders: string;
  thirdOrders: string;
  icon?: string;
  firstButton?: string;
  secondButton?: string;
  thirdButton?: string;
  cardContainerClass: string;
}

const FleetrifySecondCard = ({
  header,
  subheader,
  firstState,
  secondState,
  thirdState,
  firstOrders,
  secondOrders,
  thirdOrders,
  icon,
  firstButton,
  secondButton,
  thirdButton,
  cardContainerClass,
}: SecondCardProps) => {
  
  const rows = [
    { state: firstState, orders: firstOrders, button: firstButton },
    { state: secondState, orders: secondOrders, button: secondButton },
    { state: thirdState, orders: thirdOrders, button: thirdButton },
  ];

  return (
    <div
      className={`bg-white hide-scrollbar border border-[#143887CC] w-[50px] rounded-[8px] h-auto overflow-auto min-h-full p-[20px] ${cardContainerClass} flex flex-col`}
    >
      <p className="font-bold">{header}</p>
      <p>{subheader}</p>

    {/* Rendered Chart Content */}
      <div className="space-y-9">
        {rows.map((row, index) => (
          <div key={index} className="flex flex-row justify-between px-2 py-2">
            <div>
              <p className="m-0 font-semibold">{row.state}</p>
              <p className="m-0 text-[10px]">{row.orders}</p>
            </div>
            <div className="bg-[#D5F6E3] border border-green-400 text-[#26A65D] px-2 py-2 rounded-md text-[12px]">{row.button}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FleetrifySecondCard;
